module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/common/de-DE/btn_back.png";